import { createTheme } from '@mui/material/styles';

/** Single fixed light palette. No dark mode and no theme toggle — the
 *  staff learn one look, and a light screen survives the store's
 *  overhead lighting better than a dark one. */
export const COLORS = {
  pageBg: '#f7f8fa',
  surface: '#ffffff',
  border: '#e2e8f0',
  text: '#0f172a',
  textMuted: '#64748b',
  /** Purchase button, change due — the "go" colour. */
  accent: '#1e7f4f',
  accentDark: '#166139',
  /** Employee-pricing mode. */
  warn: '#f59e0b',
  warnBg: '#fff4e5',
  warnText: '#92400e',
  /** Employee confirm, errors. */
  danger: '#b71c1c',
  dangerBg: '#fee2e2',
} as const;

/** Minimum touch target. POS research is consistent on this: anything
 *  under ~48px gets mis-tapped by someone working fast. */
export const TOUCH_MIN = 48;

export const theme = createTheme({
  palette: {
    mode: 'light',
    background: { default: COLORS.pageBg, paper: COLORS.surface },
    primary: { main: COLORS.accent, dark: COLORS.accentDark },
    warning: { main: COLORS.warn },
    error: { main: COLORS.danger },
    text: { primary: COLORS.text, secondary: COLORS.textMuted },
  },
  typography: {
    fontFamily: '"Quicksand", "Roboto", sans-serif',
    // 16px base rather than MUI's 14 — this is read at arm's length
    // across a counter, not on a desk.
    fontSize: 16,
    button: { textTransform: 'none', fontWeight: 600 },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { minHeight: TOUCH_MIN },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: { minWidth: 40, minHeight: 40 },
      },
    },
  },
});
